import { Directive, ElementRef, OnInit, Renderer2, AfterViewInit, Input, HostListener, Injector } from "@angular/core";
import { NgControl } from "@angular/forms"; 
import { SideNavService } from "../../theme/layout/admin/navigation/service/side-nav.service";
import { CommonService } from "../common.service";

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {

  @Input("tooltipText") tooltipText: string;
  @Input("appTooltip") appTooltip: any;
  control: NgControl
  toolTipWrapperElement: HTMLElement;
  thisWidth: number = 0;

  constructor(private el: ElementRef,
    private renderer: Renderer2,
    private sidNavService: SideNavService,
    private common: CommonService,
    injector: Injector) {
    try {
      this.control = injector.get(NgControl)
    }
    catch (e) {
    }
  }

  ngOnInit() {
    this.thisWidth = (this.el.nativeElement as HTMLElement).offsetWidth;
    this.tooltipText = this.tooltipText
      ? this.tooltipText
      : this.el.nativeElement.innerText;
  }

  ngAfterViewInit() {
    debugger
    //this.toolTipTextFromModel
    this.toolTipWrapperElement = this.renderer.createElement("span");
    this.renderer.addClass(this.toolTipWrapperElement, "tooltiptext")
    this.renderer.listen(this.el.nativeElement, "mouseenter", () => {
      const isPound = this.typeOf == 'number' ? '£' : '';
      if (this.sidNavService.getShowBubble) {
        return ;
        if (this.appTooltip && !Array.isArray(this.appTooltip) && !(this.appTooltip.length > 0)) {
          this.toolTipWrapperElement.innerText = `Last year you entered: ${isPound} ` +
            (this.toolTipTextFromModel ?
              (this.typeOf == 'number' ? Number(this.toolTipTextFromModel).toFixed(2)
                : this.toolTipTextFromModel)
              : (this.typeOf == 'number' ? '' : ''));
        } else {
          var text = 'Last year you entered:<br/>';
          this.appTooltip.forEach((x, i) => {
            text += 'Record ' + (i + 1) + '--->' + isPound + (this.toolTipTextFromArray(i) ? (this.typeOf == 'number' ? Number(this.toolTipTextFromArray(i)).toFixed(2) : this.toolTipTextFromArray(i))
              : (this.typeOf == 'number' ? '' : '')) + '</br>'
            this.toolTipWrapperElement.classList.add("datatooltip")
          });
          this.toolTipWrapperElement.innerHTML = text;
        }
        this.renderer.insertBefore(
          this.el.nativeElement.parentNode,
          this.toolTipWrapperElement,
          this.el.nativeElement
        );
      }
    });
    this.renderer.listen(this.el.nativeElement, "mouseleave", () => {
      this.renderer.removeChild(
        this.el.nativeElement,
        this.toolTipWrapperElement
      );
    });
  }

  toolTipTextFromArray(index: any): any {
    const formControlName = this.el.nativeElement.attributes['formcontrolname'].value;
    if (formControlName) {
      //this.common.showbubblevalue = this.appTooltip[index][formControlName]
      return this.appTooltip[index][formControlName]
    }
    return "";
  }


  get typeOf(): any {
    const attributes = this.el.nativeElement.attributes;
    for (let i = 0; i < attributes.length; i++) {
      if (attributes[i].ownerElement.className.includes('AccountNumber ') || attributes[i].ownerElement.className.includes('MinusValue'))
        return 'number'
    }     //return typeof this.appTooltip[formControlName];
  }

  get toolTipTextFromModel() {
    debugger;
    const formControlName = this.el.nativeElement.attributes['formcontrolname'].value;
    if (formControlName) {
      this.common.showbubblevalue = this.appTooltip[formControlName]
      return this.appTooltip[formControlName]
    }
    return "";
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (e.key === 'F6' && this.sidNavService.getShowBubble) {
      this.control.control.setValue((this.toolTipTextFromModel ? (this.typeOf == 'number' ? Number(this.toolTipTextFromModel) : this.toolTipTextFromModel) : (this.typeOf == 'number' ? '0' : '')));
      e.preventDefault(); //After F6 do not navigate to URL.
    }
  }
}
